import { DataBean } from "../DataBean";

export class PayrollLiquidateType extends DataBean {


    public async getPayrollLiquidateTypeCatalog(idPayrollLiquidateType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollLiquidateTypeCatalog_Number", [idPayrollLiquidateType]);
    }


    public async getPayrollLiquidatorTypeConstants(idPayrollLiquidateType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollLiquidatorTypeConstants_Number", [idPayrollLiquidateType]);
    }

   

 
}